import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { navigate } from "../../../services";
import { PAGE_EDITOR } from "../../../settings";
import { fixArabicText, isPointInRect } from "../../../helpers";
import { EVT_MOUSEDOWN } from "../../../lib";

import { Container, MenuItem } from "./List";
import Icon from "./Icon";
import { AppState } from "../../../store";

const IndentMark = styled.div<{ indent: number }>`
    display: ${(p) => (p.indent > 0 ? "block" : "none")};
    position: relative;
    margin-left: 8px;
    width: 25px;
    border-bottom: 1px solid #fff;
    margin-bottom: 10px;
`;

type OwnProps = {
    doc_id: number;
    page_id: number;
    enableDarkTheme: boolean;
    canAdminister: boolean;
    iconElm: React.RefObject<Icon>;

    hideMenu: () => void;
};
const mapState = (state: AppState, { doc_id }: OwnProps) => ({
    //@ts-ignore
    pages: state.pages.filter((p: any) => p.get("doc_id") === doc_id),
});
type StateProps = ReturnType<typeof mapState>;
type Props = StateProps & OwnProps;

class PagesList extends React.Component<Props> {
    private elmContainer: React.RefObject<HTMLDivElement>;

    constructor(props: Props) {
        super(props);
        this.elmContainer = React.createRef<HTMLDivElement>();
    }

    componentDidMount() {
        window.addEventListener(EVT_MOUSEDOWN, this.onMouseDown);
    }

    componentWillUnmount() {
        window.removeEventListener(EVT_MOUSEDOWN, this.onMouseDown);
    }

    onMouseDown = (evt: MouseEvent) => {
        if (!this.elmContainer || !this.elmContainer.current) {
            return;
        }

        const point = { x: evt.clientX, y: evt.clientY };
        if (
            !isPointInRect(
                point,
                this.elmContainer.current.getBoundingClientRect()
            )
        ) {
            this.close();
        }
    };

    onClick = (id: number) => {
        const { doc_id } = this.props;
        navigate.to(`/app/e/${doc_id}/${id}`);

        this.close();
    };

    addNewPage = () => {
        const { doc_id } = this.props;
        navigate.to(`/app/pages/${doc_id}/create?redirect=${PAGE_EDITOR}`);
    };

    close = () => {
        this.props.hideMenu();
    };

    render() {
        const { page_id, pages, enableDarkTheme, canAdminister } = this.props;
        const list: Array<{
            id: number;
            name: string;
            indent: number;
            position: number;
        }> = [];

        pages.forEach((p: any) => {
            list.push({
                id: p.get("id"),
                name: p.get("name"),
                indent: p.get("_indent"),
                position: p.get("position"),
            });
        });

        // list.sort((a, b) => a.position - b.position)

        return (
            <Container
                textAlign="right"
                enableDarkTheme={enableDarkTheme}
                ref={this.elmContainer}
            >
                {list.map(({ id, name, indent }) => (
                    <MenuItem
                        key={`page-menu-link-${id}`}
                        enableDarkTheme={enableDarkTheme}
                        onClick={() => this.onClick(id)}
                        active={id === page_id}
                        padding="5px 15px 5px 0"
                    >
                        <IndentMark indent={indent} />
                        <span dangerouslySetInnerHTML={fixArabicText(name)} />
                    </MenuItem>
                ))}

                {canAdminister && (
                    <MenuItem
                        key="add-empty-page"
                        primary={true}
                        padding="5px 15px 5px 0"
                        onClick={this.addNewPage}
                        enableDarkTheme={enableDarkTheme}
                    >
                        <FormattedMessage id="editorMenu.addPage" />
                    </MenuItem>
                )}
            </Container>
        );
    }
}

export default connect(mapState)(PagesList);
